module.exports = __webpack_public_path__ + "static/media/nightowl-map.4d995a7f.png";